var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.08 20.24L38.08 16.12C36.94 15.7 35.08 15.7 33.94 16.12L22.94 20.24C20.82 21.04 19.1 23.52 19.1 25.78V41.98C19.1 43.6 20.16 45.74 21.46 46.7L32.46 54.92C34.4 56.38 37.58 56.38 39.52 54.92L50.52 46.7C51.82 45.72 52.88 43.6 52.88 41.98V25.78C52.9 23.52 51.18 21.04 49.08 20.24ZM42.96 31.44L34.36 40.04C34.06 40.34 33.68 40.48 33.3 40.48C32.92 40.48 32.54 40.34 32.24 40.04L29.04 36.8C28.46 36.22 28.46 35.26 29.04 34.68C29.62 34.1 30.58 34.1 31.16 34.68L33.32 36.84L40.86 29.3C41.44 28.72 42.4 28.72 42.98 29.3C43.56 29.88 43.56 30.86 42.96 31.44Z",
    fill: "#ED6E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.53a3acdcb130fe070c65caff3c15ccea.svg";
export { ForwardRef as ReactComponent };